module.exports = __webpack_public_path__ + "static/media/map-marker.c7789251.svg";